import { stringToColor } from "@core/utils/stringToColor";
import { StringAvatarProps } from "./types";

export function stringAvatar(size: number | string = 28, name?: string): StringAvatarProps {
  const fontSize = typeof size === 'number' ? size / 2 : '50%'; // Ajusta o fontSize com base no tipo de size

  const props: StringAvatarProps = {
    sx: {
      width: size,
      height: size,
    },
  };

  if (name) {
    props.sx.bgcolor = stringToColor(name);

    const [firstString, secondaryString] = name.split(" ");
    let initials = firstString[0];
    if (secondaryString) initials += secondaryString[0];

    props.children = <p style={{ fontSize }}>{initials.toUpperCase()}</p>;
  }

  return props;
}
